export const name = "publicationchannel";
export default function publicationChannel( publicationchannel ) {
	this.__publicationchannel = String( publicationchannel );
}
